import React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";
import SlackLoader from "../../assets/images/slackLoader.gif";
import GitHubLoader from "../../assets/images/githubLoader.gif";
import GitLabLoader from "../../assets/images/gitlabLoader.gif";
import JiraLoader from "../../assets/images/jiraLoader.gif";
import NotionLoader from "../../assets/images/notionLoader.gif";
import CalendarLoader from "../../assets/images/calendarLoader.gif";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    border-radius: 14px;
    width: 98%;
`;

const LoaderGif = styled.img`
    width: auto;
    height: 115px;
    opacity: 0.8;
`;
const ScrappingPlaceholderSection = ({ variant }) => {
    return (
        <BorderedStack
            spacing={7}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            <Stack direction="row" alignItems="center">
                {variant === "collaboration" && (
                    <Stack direction="row" spacing={2}>
                        <LoaderGif src={SlackLoader} alt="scrapping..." />
                        <LoaderGif src={CalendarLoader} alt="scrapping..." />
                    </Stack>
                )}
                {variant === "slack" && <LoaderGif src={SlackLoader} alt="scrapping..." />}
                {variant === "github" && <LoaderGif src={GitHubLoader} alt="scrapping..." />}
                {variant === "gitlab" && <LoaderGif src={GitLabLoader} alt="scrapping..." />}
                {variant === "jira" && <LoaderGif src={JiraLoader} alt="scrapping..." />}
                {variant === "notion" && <LoaderGif src={NotionLoader} alt="scrapping..." />}
                {variant === "google" && <LoaderGif src={CalendarLoader} alt="scrapping..." />}
            </Stack>
            <Stack alignItems="center">
                <H2> Your {variant} integration has succeeded!</H2>
                <Span>Please wait while we scrape the data</Span>
            </Stack>
        </BorderedStack>
    );
};

export default ScrappingPlaceholderSection;
